import React from 'react';

function EnterIcon() {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' className='m-auto' viewBox='0 0 24 24' fill='currentColor' width={25}>
      <title>Enter Key</title>
      <path d='M0 0h24v24H0V0z' fill='none'></path>
      <path d='M19 7v4H5.83l3.58-3.59L8 6l-6 6 6 6 1.41-1.41L5.83 13H21V7h-2z'></path>
    </svg>
  );
}

export default EnterIcon;
